import { Box, Typography } from "@mui/material";
import ProfilWidgets from "./ProfilWidgets/ProfilWidgets";
import ReactSvgIcon from "../UIElements/ReactSvgIcon";
import { ReactComponent as LogOutIcon } from "../../public/icons/profil/LogOutIcon.svg";
import { useCallback, useContext, useEffect, useState } from "react";
import { AuthContext, InnerWidthContext } from "../../contexts";
import { useClientProfil, useLocalStorage } from "../../hooks";
import { useDefaultProfil } from "../../hooks/profil/useDefaultProfil";
import { useAdminRegionNetworkProfil } from "../../hooks/profil/useAdminRegionNetworkProfil";
import { RolesEnum, Session } from "../../types";
import { sessionStorageKey } from "../../consts";
import { fetchEstbalishment } from "./Client/Common/services";

export default function ProfilHome() {
    const { logout } = useContext(AuthContext);
    const { isMobile } = useContext(InnerWidthContext);
    const [headerName, setHeaderName] = useState<string>("");

    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const {
        auth: { user: currentUser, currentUserRoleId: userRoleId },
    } = session;

    const isClient = userRoleId === RolesEnum.CLIENT;

    const customProfilHook = () => {
        // Par ce qu'on ne peux pas mettre un hook à l'intérieur d'une condition
        if (isClient) {
            return useClientProfil;
        }
        if (
            [RolesEnum.ADMIN_REGION, RolesEnum.ADMIN_RESEAU].includes(
                userRoleId
            )
        ) {
            return useAdminRegionNetworkProfil;
        }
        return useDefaultProfil;
    };

    const { profilWidgetItems } = customProfilHook()();

    const fetchEstablishment = useCallback(async () => {
        if (isClient) {
            if (currentUser?.establishment) {
                const establishementInfos = await fetchEstbalishment(
                    currentUser?.establishment
                );
                if (establishementInfos) {
                    setHeaderName(establishementInfos.companyName);
                }
            }
        }
    }, []);

    useEffect(() => {
        if (isClient) {
            fetchEstablishment();
        }
        if (currentUser.firstName && currentUser.lastName) {
            setHeaderName(currentUser.firstName + " " + currentUser.lastName);
        }
    }, []);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "3rem",
                marginLeft: "6rem",
                marginRight: "6rem",
                marginTop: "2rem",
                width: "100%",
                "@media (max-width:1024px)": {
                    marginRight: "1.5rem",
                    marginLeft: "1.5rem",
                },
            }}
        >
            {/* back */}

            {/* <BackButton back={back} /> */}
            <Box
                display={"inline-flex"}
                sx={{
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "0.5rem",
                }}
            >
                <Typography
                    sx={{
                        alignSelf: "stretch",
                        color: "#005499",
                        fontFamily: "Roboto",
                        fontSize: isMobile ? "1.5rem" : "1.75rem",
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "normal",
                    }}
                >
                    {headerName ?? ""}
                </Typography>
                <Typography
                    sx={{
                        alignSelf: "stretch",
                        color: "#023",
                        fontFamily: "Roboto",
                        fontSize: isMobile ? "1rem" : "1.125rem",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: isMobile ? "1.25rem" : "normal",
                    }}
                >
                    {`Retrouvez toutes les informations et les paramètres
                    concernant votre ${isClient ? "établissement" : "compte"}`}
                </Typography>
            </Box>

            <ProfilWidgets profilWidgetItems={profilWidgetItems} />
            <Box
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    cursor: "pointer",
                }}
                onClick={() => logout()}
            >
                <Box
                    sx={{
                        display: "flex",
                        paddingBottom: "2px",
                        alignItems: "flex-start",
                        gap: "0.625rem",
                        borderBottom: "1px solid #005499",
                    }}
                >
                    <Typography
                        sx={{
                            color: "#005499",

                            fontFamily: "Roboto",
                            fontSize: "0.875rem",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "normal",
                        }}
                    >
                        Me déconnecter
                    </Typography>
                </Box>
                <ReactSvgIcon
                    width="1.5rem"
                    height="1.5rem"
                    ReactIcon={LogOutIcon}
                />
            </Box>
        </Box>
    );
}
